@if (blog) {
  <a class="blog" [routerLink]="['/blog/post/', blog.slug]">
    <figure class="figure">
      <img class="image" [alt]="blog.title" [lazyLoad]="optimalImgSrc" />
    </figure>
    <span class="category">{{ blog.categories[0].name }}</span>
    <div class="heading">{{ blog.title }}</div>
    <div class="description">{{ blog.excerpt }}</div>
    <div class="date">{{ blog.createdDate | date: 'dd MMM yyyy' }}</div>
    <rma-blog-social-share-button class="socialContainer" [slug]="blog.slug" />
  </a>
}
